import fetch from 'cross-fetch';
import { createAction } from 'redux-api-middleware';
import Routes from '../utils/routes.js.erb';
import { API_FAILURE, authHeaders } from './index';
import { SHOW_MODAL } from './internal';
import {
  addMeta,
  tranformEmptyPayload,
  tranformSuccessPayload,
  transformBodyParams, transformErrorPayload,
} from './transformers';

export const ME_GET_REQUEST = 'ME_GET_REQUEST';
export const ME_GET_RECEIVE = 'ME_GET_RECEIVE';

export const fetchMe = (meta) => {
  return createAction(
    {
      endpoint: Routes.api_dashboard_communication_me_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [addMeta(ME_GET_REQUEST, meta), tranformSuccessPayload(ME_GET_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  );
}

export const ME_PATCH_REQUEST = 'ME_PATCH_REQUEST';
export const ME_PATCH_RECEIVE = 'ME_PATCH_RECEIVE';

export const postMe = (data, meta) => {
  return createAction(
    {
      endpoint: Routes.api_dashboard_communication_me_path(),
      headers: authHeaders(),
      method: 'PATCH',
      body: JSON.stringify(data),
      types: [addMeta(ME_PATCH_REQUEST, meta), tranformSuccessPayload(ME_PATCH_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  );
}

export const CONVERSATION_MESSAGE_CREATE_REQUEST = 'CONVERSATION_MESSAGE_CREATE_REQUEST';
export const CONVERSATION_MESSAGE_CREATE_RECEIVE = 'CONVERSATION_MESSAGE_CREATE_RECEIVE';

export const postMessage = (conversationId, bodyParams) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_create_message_path(conversationId),
    headers: authHeaders(),
    method: 'POST',
    types: [
      CONVERSATION_MESSAGE_CREATE_REQUEST,
      tranformEmptyPayload(CONVERSATION_MESSAGE_CREATE_RECEIVE, {}),
      API_FAILURE,
    ],
    body: transformBodyParams({ communication: bodyParams }),
    fetch: fetch,
  })
}

export const CONVERSATION_UPDATE_UNREAD_STATUS_REQUEST = 'CONVERSATION_UPDATE_UNREAD_STATUS_REQUEST';
export const CONVERSATION_UPDATE_UNREAD_STATUS_SUCCESS = 'CONVERSATION_UPDATE_UNREAD_STATUS_SUCCESS';
export const postUpdateUnreadStatus = (id) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_update_unread_status_path(id),
    headers: authHeaders(),
    method: 'POST',
    types: [
      CONVERSATION_UPDATE_UNREAD_STATUS_REQUEST,
      tranformEmptyPayload(CONVERSATION_UPDATE_UNREAD_STATUS_SUCCESS, {}),
      API_FAILURE,
    ],
    body: transformBodyParams({}),
    fetch: fetch,
  })
}

export const showNewMessageModal = (props = {}) => {
  return {
    type: SHOW_MODAL,
    modalType: 'COMMUNICATION_NEW_MESSAGE',
    modalProps: props,
  };
};

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_RECEIVE = 'SEND_MESSAGE_RECEIVE';
export const sendMessage = (bodyParams) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_send_message_path(),
    headers: authHeaders(),
    method: 'POST',
    types: [
      SEND_MESSAGE_REQUEST,
      tranformEmptyPayload(SEND_MESSAGE_RECEIVE, {}),
      // Tagged so the communication reducer can release the send button; the
      // default payload is kept, as the error toast reads it
      { type: API_FAILURE, meta: { type: SEND_MESSAGE_REQUEST } },
    ],
    body: transformBodyParams({ communication: bodyParams }),
    fetch: fetch,
  })
}

export const SEND_MESSAGE_GROUPS_REQUEST = 'SEND_MESSAGE_GROUPS_REQUEST';
export const SEND_MESSAGE_GROUPS_RECEIVE = 'SEND_MESSAGE_GROUPS_RECEIVE';
export const sendMessageGroups = (bodyParams) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_send_message_to_groups_path(),
    headers: authHeaders(),
    method: 'POST',
    types: [
      SEND_MESSAGE_GROUPS_REQUEST,
      tranformEmptyPayload(SEND_MESSAGE_GROUPS_RECEIVE, {}),
      // Tagged so the communication reducer can release the send button; the
      // default payload is kept, as the error toast reads it
      { type: API_FAILURE, meta: { type: SEND_MESSAGE_GROUPS_REQUEST } },
    ],
    body: transformBodyParams({ communication: bodyParams }),
    fetch: fetch,
  })
}

export const GET_FILTERS_FOR_GROUPS_REQUEST = 'GET_FILTERS_FOR_GROUPS_REQUEST';
export const GET_FILTERS_FOR_GROUPS_RECEIVE = 'GET_FILTERS_FOR_GROUPS_RECEIVE';
export const getFiltersForGroups = () => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_filters_for_groups_path(),
    headers: authHeaders(),
    method: 'GET',
    types: [
      GET_FILTERS_FOR_GROUPS_REQUEST,
      tranformSuccessPayload(GET_FILTERS_FOR_GROUPS_RECEIVE),
      API_FAILURE,
    ],
    fetch: fetch,
  })
}

export const LANGUAGE_DETECTION_REQUEST = 'LANGUAGE_DETECTION_REQUEST';
export const LANGUAGE_DETECTION_RECEIVE = 'LANGUAGE_DETECTION_RECEIVE';
export const detectLanguage = (bodyParams) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_detect_language_path(),
    headers: authHeaders(),
    method: 'POST',
    types: [
      LANGUAGE_DETECTION_REQUEST,
      tranformSuccessPayload(LANGUAGE_DETECTION_RECEIVE),
      transformErrorPayload({ originalType: LANGUAGE_DETECTION_REQUEST }),
    ],
    body: transformBodyParams({ communication: bodyParams }),
    fetch: fetch,
  })
}

export const TRANSLATE_REQUEST = 'TRANSLATE_REQUEST';
export const TRANSLATE_RECEIVE = 'TRANSLATE_RECEIVE';
export const translate = (bodyParams) => {
  return createAction({
    endpoint: Routes.api_dashboard_communication_translate_path(),
    headers: authHeaders(),
    method: 'POST',
    types: [
      TRANSLATE_REQUEST,
      tranformSuccessPayload(TRANSLATE_RECEIVE),
      transformErrorPayload({ originalType: TRANSLATE_REQUEST }),
    ],
    body: transformBodyParams({ communication: bodyParams }),
    fetch: fetch,
  })
}

export const GROUP_MESSAGES_REQUEST = 'GROUP_MESSAGES_REQUEST';
export const GROUP_MESSAGES_RECEIVE = 'GROUP_MESSAGES_RECEIVE';
export const fetchGroupMessages = (meta = {}) => {
  return createAction(
    {
      endpoint: Routes.api_dashboard_communication_group_messages_path({ page: meta.page }),
      headers: authHeaders(),
      method: 'GET',
      types: [
        addMeta(GROUP_MESSAGES_REQUEST, meta),
        tranformSuccessPayload(GROUP_MESSAGES_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    },
  );
}
